/**
 * AUDIO tab for settings panel.
 * Placeholder with volume sliders (no audio system yet).
 */

import styles from './DesignTab.module.css';

export function AudioTab() {
  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionTitle}>Volume</span>
        </div>
        <div className={styles.sectionBody}>
          <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 12, margin: '4px 0' }}>
            Audio settings coming in a future update.
          </p>
          <p style={{ color: 'rgba(255,255,255,0.3)', fontSize: 11, margin: '4px 0' }}>
            Master, SFX, and Music volume controls will be available here.
          </p>
        </div>
      </div>
    </div>
  );
}
